<template>
    <v-footer class="font-weight-light" absolute app>
        <v-col class="text-left" cols="12">
            © {{ new Date().getFullYear() }} Tarkenton Companies. All Rights Reserved
        </v-col>
    </v-footer>
</template>

<script>
    export default {
        name: 'app-footer'
    }
</script>

<style lang="scss" scoped>

</style>